<template>
  
  <v-card style="border-radius: 10px !important;">
    
    <div class="c-d-flex c-align-center">
      <v-icon color="success" class="ml-3 mr-2" v-if="request.submitted">done_all</v-icon>
      <v-icon color="error" class="ml-3 mr-2" v-else-if="request.rejected">block</v-icon>
      <v-icon color="info" class="ml-3 mr-2" v-else>hourglass_empty</v-icon>
      <div class="py-2 px-2 c-flex-grow-1">
        <div class="body-2 font-weight-bold">
          Signature Request by {{request.createdBy.fullName}}
        </div>
        <div class="caption" v-if="request.prompt" style="white-space: normal !important;">
          {{request.prompt}}
        </div>
      </div>
    </div>
    
    
    
    <v-divider></v-divider>
    
    <v-card-text class="py-2 px-2">
      <div
          class="body-2"
          v-if="!request.submitted"
      >
        <app-general-file-viewer
            :card-props="{flat: true}"
            :document-id="request.document.documentId"
            :filename="request.document.filename"
            :size="request.document.size"
        />
      </div>
      <div
          class="body-2"
          v-else-if="request.signedDocument"
          :draggable="draggable"
          @dragstart="(event) => callDragStartHandler(event, request.signedDocument, 'chatAttachmentDocument')"
      >
        <app-general-file-viewer
            :card-props="{flat: true}"
            :document-id="request.signedDocument.documentId"
            :filename="request.signedDocument.filename"
            :size="request.signedDocument.size"
        />
      </div>
    </v-card-text>
    
    <v-divider></v-divider>
    
    <v-card-actions v-if="request.targetId && !request.submitted" class="text-center d-flex justify-center pt-2 mt-0">
<!--      <v-btn @click="console.log(request)"></v-btn>-->
      <div v-if="loadingContactInfo" class="c-d-flex c-align-center c-justify-center">
        fullName
        mobile
      </div>
      <div v-else-if="contactInfo">
        <div class="caption text--lighten-1">Targeted To:</div>
        
        <div class="c-d-flex c-align-center pt-1 pl-2">
          <div>
            
            <div
                class="avatar-circle c-d-flex c-align-center c-justify-center white--text"
                style="width: 40px; height: 40px; border-radius: 50%;"
                :style="{
                        background: getColor()({ shades: ['800'], text: contactInfo.fullName}),
                      }"
            >
              <div class="body-1 font-weight-bold white--text">{{ getInitials(contactInfo.fullName) }}</div>
            </div>
          </div>
          
          <div class="pl-2">
            <div class="body-2 font-weight-bold">
              {{ contactInfo.fullName }}
            </div>
            <div class="caption">
              {{ contactInfo.mobile }}
            </div>
          </div>
        </div>
      
      </div>
      
<!--      {{contactInfo}}-->
      
      
      
<!--      <v-btn-->
<!--          :block="true"-->
<!--          color="primary"-->
<!--          variant="elevated"-->
<!--          text="Open Request"-->
<!--          prepend-icon="edit"-->
<!--          @click="showInformationRequest = true"-->
<!--      >-->
<!--      </v-btn>-->
<!--    -->
    </v-card-actions>
<!--    -->
    <v-card-actions class="pt-0 mt-0" v-else-if="request.submitted">
      <div>
        <div class="caption text--lighten-1">
          Signed By:
        </div>
        
        <div class="c-d-flex c-align-center pt-1 pl-2">
          <div>
            
            <div
                class="avatar-circle c-d-flex c-align-center c-justify-center white--text"
                style="width: 40px; height: 40px; border-radius: 50%;"
                :style="{
              background: getColor()({ shades: ['800'], text: request.submittedName}),
            }"
            >
              <div class="body-1 font-weight-bold white--text">{{ getInitials(request.submittedName) }}</div>
            </div>
          </div>
          
          <div class="pl-2">
            <div class="body-2 font-weight-bold">
              {{ request.submittedName }}
            </div>
            <div class="caption">
              {{ format(new Date(request.submittedDate), 'YYYY-MM-DD HH:mm') }}
            </div>
          </div>
        </div>
      </div>
    </v-card-actions>
    
    <v-card-actions class="pt-2 mt-0" v-else-if="request.rejected">
      <div>
        <div class="caption text--lighten-1">
          Rejected By:
        </div>
        
        <div class="c-d-flex c-align-center pt-1 pl-2">
          <div>
            
            <div
                class="avatar-circle c-d-flex c-align-center c-justify-center white--text"
                style="width: 40px; height: 40px; border-radius: 50%;"
                :style="{
              background: getColor()({ shades: ['800'], text: request.rejectedName}),
            }"
            >
              <div class="body-1 font-weight-bold white--text">{{ getInitials(request.rejectedName) }}</div>
            </div>
          </div>
          
          <div class="pl-2">
            <div class="body-2 font-weight-bold">
              {{ request.rejectedName }}
            </div>
            <div class="text--disabled caption font-italic" v-html="request.rejectedReason?.replaceAll('\n', '<br />')" />
            <div class="caption">
              {{ format(new Date(request.rejectedDate), 'YYYY-MM-DD HH:mm') }}
            </div>
          </div>
        </div>
      </div>
    </v-card-actions>
  </v-card>

</template>


<script>
import {format} from 'date-fns'
import AppGeneralFileViewer from "@/components/General/AppGeneralFileViewer.vue";
import {getInitials} from "../codeFunctions";
import {getColor} from "random-material-color/dist/randomColor";

export default {
  components: {AppGeneralFileViewer},
  props: {
    request: {
      type: Object,
      required: true
    },
    messageId: Number,
    callDragStartHandler: Function,
    draggable: {type: Boolean, default: false},
  },
  data() {
    return {
      loadingContactInfo: false,
      contactInfo: null,
    }
  },
  
  watch: {
    "request.targetId": {
      immediate: true,
      handler(val) {
        if (val)
          this.fetchContactInfo()
      }
    }
  },
  methods: {
    getColor() {
      return getColor
    },
    getInitials,
    format,
    async fetchContactInfo() {
      try {
        this.loadingContactInfo = true
        this.contactInfo = await this.$newReq('GET', `contacts/contactInfo/${this.request.targetId}`)
      } catch (e) {
        console.log(e)
        
      } finally {
        this.loadingContactInfo = false
      }
    }
  },
}
</script>


<style scoped>

</style>